<template>
  <div class="goodsManageAddPage">
    <van-image width="100%" fit="scale-down" :src="detail.actcover" />

    <div class="main_content">
      <div class="good_description">
        <div class="item">
          <div class="block">
            <p>
              活动名称：<span>{{ detail.actname }}</span>
            </p>
            <p>
              活动城市：<span>{{ detail.city }}</span>
            </p>
            <p>
              活动地标：<span>{{ detail.position }}</span>
            </p>
            <p>
              活动关联门店：<span>{{ detail.shopcodestr }}</span>
            </p>
            <p>
              企业关联业务端场景：<span>{{ detail.linkappidstr }}</span>
            </p>
          </div>

          <div class="block" style="margin: 20px 0">
            <p>
              开始预约日期：<span>{{ detail.joinsdate | formatDate }}</span>
            </p>
            <p>
              结束预约日期：<span>{{ detail.joinedate | formatDate }}</span>
            </p>
            <p>
              活动开始日期&时间：<span>{{ detail.sdate | formatDate }}</span>
            </p>
            <p>
              活动结束日期&时间：<span>{{ detail.edate | formatDate }}</span>
            </p>
            <p>
              活动花费类型：<span>{{ detail.costtype }}</span>
            </p>
            <p>
              是否仅限会员参加：<span>{{ detail.isactpermis }}</span>
            </p>
          </div>

          <div class="block">
            <p>
              创建日期：<span>{{ detail.createdate | formatDate }}</span>
            </p>
            <p>
              创建人姓名：<span>{{ detail.truename }}</span>
            </p>
            <p>
              创建人手机号：<span>{{ detail.mobile }}</span>
            </p>
            <p>
              创建人所属企业：<span>{{ detail.appidstr }}</span>
            </p>
          </div>
        </div>
      </div>

      <div class="good_operation flex-between">
        <a
          href="javascript:;"
          class="item"
          @click="handleGo(detail.id, 'addShop')"
          >基础信息设置</a
        >
        <a
          href="javascript:;"
          class="item"
          @click="handleGo(detail.id, 'activityRecord')"
          >活动预约记录</a
        >
        <a
          href="javascript:;"
          class="item"
          @click="handleGo(detail.id, 'shopBanner')"
          >活动banner</a
        >
        <a
          href="javascript:;"
          class="item"
          @click="handleGo(detail.id, 'activityList')"
          >活动详情</a
        >
      </div>
    </div>

    <!-- <div class="primary-button return" @click="handleReturn">
      <i class="iconfont icon-yuyinjiantou"></i>返回
    </div> -->
    <div class="fixd_button_btm flex-rowl">
      <!-- <div class="return-fixd"> -->
      <div class="item return" @click="handleReturn">返回</div>
    </div>
  </div>
</template>

<script>
import { encryptstringadd, encryptstringview } from "../../api/api";
import { getActivityDetail } from "../../api/shop";
import { mapState } from "vuex";
import Clipboard from "clipboard";
export default {
  name: "shopDetail",
  data() {
    return {
      id: "",
      tabbarActive: 0,
      bannerList: "", // 商品banner
      brandList: "", // 品牌列表
      shopLabelFirst: "", // 商品所属分类

      detail: "", // 详情列表
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList } = this.$store.state;
    let { name } = this.$route;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, this.OPENID);
    }
  },
   filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.getActivityDetail(id);
      } else {
        this.$router.back();
      }
    },

    getActivityDetail(id) {
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      getActivityDetail({ id }).then((res) => {
        this.detail = res;
        Toast.clear();
      });
    },

    // 复制
    handleCopyBtn() {
      let clipboard = new Clipboard(".copy_box");
      clipboard.on("success", () => {
        // console.log("复制成功",e);
        this.$toast.success("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        console.log("该浏览器不支持自动复制", e);
        if (e.text) {
          this.$toast.fail("复制失败");
        } else {
          this.$toast("暂无内容");
        }
        // 释放内存
        clipboard.destroy();
      });
    },

    handleReturn() {
      history.back();
    },

    handleGo(id, name) {
      console.log(id, name, "-==-=====");
      this.encryptstringadd(name, { id });
    },
    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.goodsManageAddPage {
  font-size: 26px;
  color: #404d6c;
  padding-bottom: 210px;
  .my-swipe {
    height: 750px;
    background: #f8f8f8;
  }
  .good_description {
    padding: 96px 70px 150px;
    .item {
      margin-bottom: 38px;
      p {
        margin-bottom: 15px;
      }
    }
  }
  .good_operation {
    font-size: 26px;
    color: #eb1b3d;
    flex-flow: row wrap;
    margin-bottom: 180px;
    a {
      color: #eb1b3d;
    }
    .item {
      flex-shrink: 0;
      width: 50%;
      text-align: center;
      height: 90px;
      line-height: 90px;
      border-bottom: 1px solid #adadad;
      box-sizing: border-box;
      &:nth-child(2n-1) {
        border-right: 1px solid #adadad;
      }
      &:nth-child(1),
      &:nth-child(2) {
        border-top: 1px solid #adadad;
      }
    }
  }
  .fixd_button_btm {
    .item {
      flex: 1;
    }
  }
}
</style>